export function clipboard(el, { value, modifiers, expression }, { cleanup }) {
    let text = el.textContent;

    el.addEventListener("click", () => {
        navigator.clipboard.writeText(text);
    });

    cleanup(() => {
        el.removeEventListener("click", () => {});
    });
}

export function regexp_check(
    el,
    { value, modifiers, expression },
    { cleanup }
) {
    let onInput = (e) => {
        e.preventDefault();
        // e.stopImmediatePropagation();

        if (e.detail && e.detail.isCustom) return;

        const cursorPosition = el.selectionStart; // Get the current cursor position
        const previousValue = el.value; // Store the previous value
        const modifier = value;
        let reg_exp = null;
        if (modifier) {
            reg_exp = new RegExp(expression, modifier);
        } else {
            reg_exp = new RegExp(expression);
        }

        if (!reg_exp.test(el.value)) {
            let val =
                previousValue.slice(0, cursorPosition - 1) +
                previousValue.slice(cursorPosition); // Remove the last character before cursor

            el.value = val;
            el.setSelectionRange(cursorPosition - 1, cursorPosition - 1); // Move the cursor position back

            // Dispatch the input event with custom detail
            el.dispatchEvent(
                new CustomEvent("input", {
                    bubbles: true,
                    detail: { isCustom: true }, // Indicate this is a custom event
                })
            );
            // el.dispatchEvent(new Event("input")); // Trigger input event
        }
    };

    el.addEventListener("input", onInput, { capture: true });

    // Register any cleanup code inside `cleanup()` in the case
    // where a Livewire component is removed from the DOM while
    // the page is still active.
    cleanup(() => {
        el.removeEventListener("click", onInput);
    });
}

export function external_link(el, { expression }, { evaluate }) {
    el.addEventListener("click", (event) => {
        event.preventDefault(); // Prevent the default link action
        const url = el.getAttribute("href"); // Get the URL from the link
        // const message = evaluate(expression); // Evaluate the expression, which should return the message

        $wireui.confirmDialog({
            title: "Are you sure?",
            description:
                "This link will take you external website. Do you wan to proceed?",
            accept: {
                label: "Yes",
                execute: () => {
                    window.open(url, "_blank");
                },
            },
            reject: {
                label: "No",
            },
        });
    });
}

export function no_clipboard(el, { expression }, { evaluate }) {}

export function encrypt(el, { value, modifiers, expression }, { cleanup }) {
    el.addEventListener("blur", async () => {
        let componentId = el.getAttribute("data-component-id");
        let propertyName = el.getAttribute("name");
        let publicKey = window.Livewire.find(componentId).$get("key");
        let plainText = el.value;

        if (!publicKey) {
            alert("Key Not available !!! cannot proceed further");
            return;
        }

        if (plainText == "") {
            Livewire.find(componentId).$set(propertyName, "", false);
            return;
        }

        try {
            //clean public key by removing characters
            let publicKeyCleaned = publicKey
                .replace(
                    /-----BEGIN PUBLIC KEY-----|-----END PUBLIC KEY-----|\n/g,
                    ""
                )
                .trim();

            // Convert the publicKey from Base64 to ArrayBuffer
            let keyBuffer = Uint8Array.from(atob(publicKeyCleaned), (c) =>
                c.charCodeAt(0)
            ).buffer;

            // Import the publicKey
            let cryptoKey = await window.crypto.subtle.importKey(
                "spki",
                keyBuffer,
                { name: "RSA-OAEP", hash: "SHA-1" },
                true,
                ["encrypt"]
            );

            // Encrypt the plainText using the publicKey
            let encryptedArrayBuffer = await window.crypto.subtle.encrypt(
                { name: "RSA-OAEP" },
                cryptoKey,
                new TextEncoder().encode(plainText)
            );

            // Convert the encrypted data to Base64
            let encryptedBase64 = btoa(
                String.fromCharCode.apply(
                    null,
                    new Uint8Array(encryptedArrayBuffer)
                )
            );

            // Save encrypted data back to the element (for demonstration, we store it in a data attribute)
            if (el.hasAttribute("update")) {
                el.value = encryptedBase64; // the assignment is two way i guess
                return;
            }

            // let newValue = el.value; // Get the value from the element (assuming it's an input)
            //     el.dispatchEvent(new Event('input')); // updating the livewire property though telling it that element value has changed
            //    return;
            Livewire.find(componentId).$set(
                propertyName,
                encryptedBase64,
                false
            );

            // el.setAttribute('data-encrypted', encryptedBase64);
        } catch (error) {
            console.error("Javascript Not Working:", error);
        }
    });

    cleanup(() => {
        el.removeEventListener("blur", () => {});
    });
}
